import React from 'react';
import { CatalogItemType } from '@common/model/catalog/item/type';
import { mergeSx } from '@cp/ds/src/utils/sx/merge';
import { Stack } from '@cp/ds/src/components/stack';
import { SORTING_ITEMS, SORTING_ITEMS_VACANCY } from '../model';
import { SortButton } from './sortButton';
import { CatalogNavViewProps } from './model';

const ViewDesktop: React.FC<CatalogNavViewProps> = ({ sx, catalogType, citySearchFormField }) => {
  const containerSx = React.useMemo(
    () =>
      mergeSx(
        {
          width: '100%',
          alignItems: 'flex-start',
        },
        sx,
      ),
    [sx],
  );

  const sortingItems = catalogType === CatalogItemType.Vacancy ? SORTING_ITEMS_VACANCY : SORTING_ITEMS;

  return (
    <Stack component="form" gap={1.5} noValidate sx={containerSx}>
      {citySearchFormField}
      <SortButton sortingItems={sortingItems} />
    </Stack>
  );
};

export default ViewDesktop;
